<template>
  <mmp-modal v-bind="componentAttrs" title="이용약관" v-on="listeners">

    <template v-slot:header>
      <div class="popup_title">
        이용약관
      </div>
      <button type="button" class="btn_close" @click="$emit('close')"><span class="blind">팝업 닫기</span></button>
    </template>

    <template v-slot:content>
      <div class="notice_box">
        <div v-dompurify-html="rawHtml"/>
      </div>
    </template>
    <template v-slot:footer><div/></template>
  </mmp-modal>
</template>

<script>

export default {
  name: 'NrwFooterTerm',
  props: {
  },
  data () {
    return {
      rawHtml: ''
    }
  },
  computed: {
    isValidParam () {
      return true
    }
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.getTerm()
  },
  methods: {
    async getTerm () {
      var useTermsResult = await this.$http.busn.getUseTerms(this, {})

      if (useTermsResult.data.status === 'OK') {
        this.$set(this, 'rawHtml', useTermsResult.data.data.useTerms.termsCntnt )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwFooterTerm.vue